module.exports = __webpack_public_path__ + "img/20-09-2021-711x800.792df1f2.jpg";